import {
  TranslationConcretingRequestMessages,
  ConcretingRequestMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationConcretingRequestMessages = {
  [ConcretingRequestMessages.stepContractText]: "Contract",
  [ConcretingRequestMessages.stepConcretingText]: "Concreting",
  [ConcretingRequestMessages.stepConcreteRecipeText]: "Concrete Recipe",
  [ConcretingRequestMessages.stepPumpText]: "Pump",
  [ConcretingRequestMessages.requestNewConcretingText]:
    "Request new concreting",
  [ConcretingRequestMessages.clientWithPendencyText]:
    "Client has a pendency, contact with the commercial.",
  [ConcretingRequestMessages.messagesDialogTitle]: "Messages",
  [ConcretingRequestMessages.messageUnderReview]:
    "Concreting Request under analysis. Soon you will receive confirmation or not of the request.",
  [ConcretingRequestMessages.contractWithPendenciesMessage]:
    "This contract has pendencies, please contact the finance department.",
  [ConcretingRequestMessages.inactiveContractMessage]:
    "This contract is inactive, please contact the finance department."
};
